import { atom } from 'recoil'
import { IProjectCheckpointCriterion } from './projectCheckpoints.types'

interface ICheckpointCriteriaAtom {
  /**
   * Map of checkpoints ids and their criteria
   */
  items: Record<string, IProjectCheckpointCriterion[]>
}

const checkpointsCriteriaAtom = atom<ICheckpointCriteriaAtom>({
  key: 'project-checkpoints/criteria',
  default: { items: {} },
})
export default checkpointsCriteriaAtom
